module.exports = __webpack_public_path__ + "img/summary_6.06bb1b4e.png";